import { trackEvent } from "../lib/analytics";

export type NewYearBookingSource =
  | "home_announcement"
  | "invite_popup"
  | "afisha_event"
  | "new_year_page_hero"
  | "new_year_page_footer"
  | "site_top_banner";

/** Measures intent only, not a confirmed reservation in Remarked. */
export function openNewYearBooking(source: NewYearBookingSource) {
  trackEvent("new_year_booking_click", { source, campaign: "new_year_2027" });
  openBookingModal();
}

export function openBookingModal() {
  if (typeof window === "undefined") return;
  try {
    if (typeof (window as any).ym === "function") {
      (window as any).ym(109746755, "reachGoal", "booking");
    }
  } catch {
    // Legacy analytics must not prevent Remarked from opening either.
  }
  window.open("https://remarked.ru/widget/new/points/726106/726106.html", "_blank", "noopener,noreferrer");
}

export function BookingModal() {
  return null;
}
